export const tribeSiteHeader = () => {
  const $tribeSiteHederWrapper = document.querySelector(
    ".tribe-site-header__wrapper"
  );
  if ($tribeSiteHederWrapper) {
    const $tribeHeaderSearchDesktop = $tribeSiteHederWrapper.querySelector(
      ".tribe-site-header__search.tribe-site-header__search--desktop"
    );
    const $tribeHeaderSearchMobile = $tribeSiteHederWrapper.querySelector(
      ".tribe-site-header__search.tribe-site-header__search-mobile"
    );
    if ($tribeHeaderSearchDesktop) {
      const $searchButton = $tribeHeaderSearchDesktop.querySelector(
        ".tribe-site-header__icon--search"
      );
      const $searchDesktop = $tribeHeaderSearchDesktop.querySelector(
        ".search-full-screen__overlay.search-full-screen__overlay--desktop"
      );
      const $overlay = $tribeHeaderSearchDesktop.querySelector(
        ".search-menu__overlay"
      );
      $searchButton.addEventListener("click", (event) => {
        event.preventDefault();
        if (
          $searchDesktop.classList.contains(
            "search-full-screen__overlay--active"
          )
        ) {
          $searchDesktop.classList.remove(
            "search-full-screen__overlay--active"
          );
        } else {
          $searchDesktop.classList.add("search-full-screen__overlay--active");
        }
      });

      $overlay.addEventListener("click", (event) => {
        event.preventDefault();
        $searchDesktop.classList.remove("search-full-screen__overlay--active");
      });
    }

    if ($tribeHeaderSearchMobile) {
      const $searchButton = $tribeHeaderSearchMobile.querySelector(
        ".tribe-site-header__icon--search"
      );
      const $searchMobile = $tribeHeaderSearchMobile.querySelector(
        ".search-full-screen__overlay.search-full-screen__overlay--mobile"
      );
      const $overlay = $tribeHeaderSearchMobile.querySelector(
        ".search-menu__overlay"
      );
      $searchButton.addEventListener("click", (event) => {
        event.preventDefault();
        if (
          $searchMobile.classList.contains(
            "search-full-screen__overlay--active"
          )
        ) {
          $searchMobile.classList.remove("search-full-screen__overlay--active");
        } else {
          $searchMobile.classList.add("search-full-screen__overlay--active");
        }
      });

      $overlay.addEventListener("click", (event) => {
        event.preventDefault();
        $searchMobile.classList.remove("search-full-screen__overlay--active");
      });
    }
  }
};

export default tribeSiteHeader;
